import { css } from '@emotion/css';

const appContainer = css({
  height: '100%',
  display: 'flex',
  backgroundColor: '#f9f4ef',
  color: '#222',
  transition: 'all .2s ease',
  '& .linkThemeStyle': {
    fontSize: 'inherit',
    fontFamily: 'inherit',
    color: '#8c7851',
    textDecoration: 'none',
    transition: 'all .2s ease',
    '&:visited': {
      color: '#51658c',
    },
    '&:hover': {
      color: '#b29c59',
      textDecoration: 'underline',
    },
  },
});

export default appContainer;
